module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutPage"
  }, [_c('div', {
    staticClass: "fullpage-container hidden-sm-down"
  }, [_c('div', {
    staticClass: "visual_switch"
  }, [_c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct === 0
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct === 1
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(1)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bgImg"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "fullpage-wp"
  }, [_c('div', {
    staticClass: "page-1 page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__subTitle"
  }, [_vm._v("\n          多年歷史，配方專業獨特，真正殺蟲的專家。\n        ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-2 page"
  }, [_c('contact'), _vm._v(" "), _c('div', {
    staticClass: "pageControl",
    attrs: {
      "id": "bottomArrow"
    }
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.movePrevPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])]), _vm._v(" "), _c('henkel-footer')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullpage-container__title"
  }, [_vm._v("\n          關於「威滅"), _c('sup', {
    staticClass: "fullpage-container__title__tm"
  }, [_vm._v("®")]), _vm._v("」\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullpage-container__bottomPanel"
  }, [_c('p', {
    staticClass: "fullpage-container__bottomPanel__text1"
  }, [_vm._v("\n            威滅"), _c('sup', [_vm._v("®")]), _vm._v("為德國Henkel家用品牌旗下的一個核心殺蟲劑品牌，備有25年的歷史，專門針對和利用害蟲的生態習性，為消費者的家居提供高效用的產品，以改善及優化生活，為用家提供健康舒適的居住環境。\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "fullpage-container__bottomPanel__text2"
  }, [_vm._v("\n            產品當中的「速效曱甴藥餌」及「速效殺蟻藥餌」，其連環殺滅功效顯著，能有效將巢穴裡的曱甴及螞蟻一網打盡! 所以威滅"), _c('sup', [_vm._v("®")]), _vm._v("一直以來深受消費者信賴和喜愛，更多年來穩佔全港藥餌銷量No.1的殊榮。 \n          ")]), _vm._v(" "), _c('img', {
    staticClass: "fullpage-container__bottomPanel__productImage",
    attrs: {
      "src": require("../assets/about-section2.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "claimRef"
  }, [_c('div', [_vm._v("\n              *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/about-section1.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section2"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        關於「威滅"), _c('sup', {
    staticClass: "title__tm"
  }, [_vm._v("®")]), _vm._v("」\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n        多年歷史，配方專業獨特，真正殺蟲的專家。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "text1"
  }, [_vm._v("\n          威滅"), _c('sup', [_vm._v("®")]), _vm._v("為德國Henkel家用品牌旗下的一個核心殺蟲劑品牌，備有25年的歷史，專門針對和利用害蟲的生態習性，為消費者的家居提供高效用的產品，以改善及優化生活，為用家提供健康舒適的居住環境。\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text2"
  }, [_vm._v("\n          產品當中的「速效曱甴藥餌」及「速效殺蟻藥餌」，其連環殺滅功效顯著，能有效將巢穴裡的曱甴及螞蟻一網打盡! 所以威滅"), _c('sup', [_vm._v("®")]), _vm._v("一直以來深受消費者信賴和喜愛，更多年來穩佔全港藥餌銷量No.1的殊榮。 \n        ")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/about-section2-m.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "claimRef"
  }, [_c('div', [_vm._v("\n          *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e6f65de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 235
// module chunks = 0